/* export const api_url = 'https://rewardsly.io/members';
export const base_url = 'http://localhost:300'; */

const api_url_dev = 'http://localhost/rewardsly';
const api_url_prod = 'https://rewardsly.io/members';

export const api_url = process.env.NODE_ENV === 'development' ? api_url_dev : api_url_prod;
